import { emit } from "../../../../core/state.js";
import { renderInlineMarkdown } from "../../../../services/markdown.js";

export default class QuizQuestion {
  render(message) {
    const { question = "", options = [], showForm = false } = message.data || {};
    const row = document.createElement("div");
    row.className = "ws-bot-row ws-quiz-row";
    if (message.isFirstResponse) row.classList.add("ws-fr");

    const avatar = document.createElement("span");
    avatar.className = "ws-avatar ws-bot-avatar ws-quiz-avatar-spacer";
    avatar.setAttribute("aria-hidden", "true");

    const wrap = document.createElement("div");
    wrap.className = "ws-quiz-option-container";

    if (question) {
      const q = document.createElement("div");
      q.className = "ws-quiz-question";
      q.innerHTML = renderInlineMarkdown(question);
      wrap.appendChild(q);
    }

    const opts = document.createElement("div");
    opts.className = "ws-quiz-options";
    (options || []).forEach((opt, index) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "ws-quiz-option-btn";
      btn.textContent = `${String.fromCharCode(65 + index)}. ${opt}`;
      btn.addEventListener("click", () => {
        if (btn.disabled) return;
        opts.querySelectorAll(".ws-quiz-option-btn").forEach((b) => {
          b.disabled = true;
        });
        btn.classList.add("is-selected");
        emit("ws-quiz-option", { value: String(opt) });
      });
      opts.appendChild(btn);
    });
    wrap.appendChild(opts);

    if (showForm) {
      wrap.appendChild(this._buildForm());
    }

    row.appendChild(avatar);
    row.appendChild(wrap);
    return row;
  }

  _buildForm() {
    const form = document.createElement("div");
    form.className = "ws-quiz-form-container";

    form.innerHTML = `
      <div class="ws-quiz-form-head">
        <p class="ws-quiz-form-title">🎉 Quiz Complete!</p>
        <div class="ws-quiz-form-description">Please enter your details to receive your personalised wine recommendations.</div>
      </div>
      <div class="ws-quiz-fields">
        <div class="ws-quiz-field-group">
          <label>Name</label>
          <input class="ws-quiz-field-username" type="text" placeholder="Enter your name" />
          <small class="ws-quiz-error-username"></small>
        </div>
        <div class="ws-quiz-field-group">
          <label>Email</label>
          <input class="ws-quiz-field-email" type="email" placeholder="Enter your email" />
          <small class="ws-quiz-error-email"></small>
        </div>
      </div>
      <div class="ws-quiz-form-footer">
        <button type="button" class="ws-quiz-form-submit">Submit</button>
        <p class="ws-quiz-skip" role="button" tabindex="0">Skip. I don't want recommendations</p>
      </div>
    `;

    const submit = form.querySelector(".ws-quiz-form-submit");
    const skip = form.querySelector(".ws-quiz-skip");
    const usernameField = form.querySelector(".ws-quiz-field-username");
    const emailField = form.querySelector(".ws-quiz-field-email");
    const usernameError = form.querySelector(".ws-quiz-error-username");
    const emailError = form.querySelector(".ws-quiz-error-email");

    const doSubmit = () => {
      const username = usernameField.value.trim();
      const email = emailField.value.trim();
      usernameError.textContent = "";
      emailError.textContent = "";

      if (!/\S/.test(username)) {
        usernameError.textContent = "Enter valid username";
        usernameField.focus();
        return;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        emailError.textContent = "Enter valid email address";
        emailField.focus();
        return;
      }

      submit.disabled = true;
      submit.classList.add("submitted");
      emit("ws-quiz-submit", { fullName: username, email });
    };

    submit.addEventListener("click", doSubmit);
    skip.addEventListener("click", () => emit("ws-quiz-skip"));
    skip.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        emit("ws-quiz-skip");
      }
    });

    return form;
  }
}
